import React, {Component} from 'react';
import {Grid} from 'semantic-ui-react';

class PartDescription extends Component {
  constructor(props) {
    super(props);
    this.state = {'showDescriptionExpanded': false};
    this.showCompleteDescription = this.showCompleteDescription.bind(this);
  }

  showCompleteDescription() {
    this.setState({'showDescriptionExpanded': true});
  }

  renderNumericValue(width, value = 0) {
    return <Grid.Column width={width}>{value}</Grid.Column>;
  }

  renderLabel(width, label, paddingLeft) {
    const classes = paddingLeft ? 'padding-left' : '';
    return (
      <Grid.Column width={width} className={classes}>
        <span className='bolder'>{label}</span>
      </Grid.Column>
    );
  }

  renderDescription(value = '') {
    const description = value || '';
    if (!this.state.showDescriptionExpanded && description.length > 180) {
      return (
        <div>
          {description.substring(0, 180)}
          <span
            className='link'
            onClick={this.showCompleteDescription}
          >
            Ver Más
          </span>
        </div>
      );
    }
    return <div>{description}</div>;
  }

  render() {
    const {data} = this.props;

    return (
      <Grid.Row>
        <Grid columns='equal'>
          <Grid.Row>
            {this.renderLabel(5, 'PNC', true)}
            {this.renderNumericValue(3, data.pnc)}
          </Grid.Row>
          <Grid.Row>
            {this.renderLabel(5, 'Partida Arancelaria', true)}
            {this.renderNumericValue(3, data.tariffHeading)}
          </Grid.Row>
          <Grid.Row>
            {this.renderLabel(5, 'Descripción', true)}
            <Grid.Column width={11} textAlign='justified'>
              {this.renderDescription(data.description)}
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Grid.Row>
    );
  }
}

export default PartDescription;
